import React from "react";
import './c53_tutte_le_storie.scss';
import {isMobileOnly} from "react-device-detect";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import magnifier from '../../assets/magnifier.svg';
import DoubleTemplateComponent
    from "../../containers/template_page/double_template_component/double_template_component";
import axios from "axios";
import { API_CONFIG } from '../../config/api_config';
import ReactPlayer from "react-player";
import {insertHtml} from "../../utils/dom";

const SVG_ID = "#svg_id";

class TutteLeStorie extends DoubleTemplateComponent {

    uuid = '';

    constructor(props) {
        super(props);
        this.state = {
            optionsCategory: [],
            arrayCallCat: [],
            disabled: true,
            searchTerm: '',
            isHidden: false,
            filters: ['title', 'date'],
            isVideoHidden: false,
            playing: false
        };
        this.myRef = React.createRef();
        //this.vidCardRef = React.createRef();
        this.requireInternationalization = true;
    };

    componentDidMount() {
        super.componentDidMount();
        this.loadTaxonomy();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate(prevProps, prevState, snapshot);
        if (this.props.language !== prevProps.language) {
            this.loadTaxonomy();
        }
    }

    loadTaxonomy() {
        // create select options before render html elements
        const epCategory = `${API_CONFIG.BASE_URL}/terms/${this.props.language}/categoria_news`;
        axios.get(epCategory).then(res => {
            this.setState({
                optionsCategory: res.data.terms.map(el => el.label),
                arrayCallCat: res.data.terms
            });
            this.state.optionsCategory.unshift('All');
        });
    }

    callFilter = () => {

        var params = {};
        params['views'] = true;
        params['limit'] = 9;

        let category = this.uuid;
        if (category) {
            params['category'] = category;
        }

        if (document.forms.searchForm && document.forms.searchForm.search && document.forms.searchForm.search.value) {
            params['search'] = document.forms.searchForm.search.value;
        }

        axios.get(this.state.data.__data, {params: params}).then(res => {
            this.setState({
                data: {...this.state.data, ...res.data},
                searchTerm: res.data.title
            });
        });
    };

    changeCategory = selected => {

        selected = selected.value;
        this.getValCat(selected);
        if (selected === 'All') {
            selected = '';
            this.uuid = '';

            this.setState({
                selected: selected
            });

            this.callFilter();
        }

        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.arrayCallCat.forEach((filterString) => {
            for (var key in filterString){
                if(filterString[key] === selected){
                    this.uuid = filterString.id;
                    this.setState({
                        selected: filterString.id
                    });
                    return this.callFilter();
                }
            }
        })
    };

    getValCat = val =>{
        this.setState ({valueCat: val});
    };

    searchUpdated = event => {
        event.preventDefault();
        this.callFilter();
    };

    //ep -> end point url to call
    showMore = ep => {
        axios.get(ep, {
        }).then(res => {

            let cards = this.state.data.cards.concat(res.data.cards);

            this.setState({
                callMore: true,
                data: {...this.state.data, ...{cards: cards, next_page: res.data.next_page}}
            });
        });
    };

    playVideo = () => {
        this.setState({
            isHidden: true,
            playing: true
        })
    };

    internationalComponentRender(allData) {
        console.log('[LOG]: ALLDATA: ', allData);

        let filteredCards = allData.cards;

        /* State */
        const {valueCat, isHidden} = this.state;

        return (
            <div id={!isMobileOnly ? 'tutte-le-storie' : 'tutte-le-storie-mob'} className="c53-tuttelestorie">
                <div className="container container-search-fields">
                    <div className="row">
                        <Dropdown
                            options={this.state.optionsCategory}
                            onChange={this.changeCategory}
                            value={valueCat}
                            placeholder="All"
                            className={!isMobileOnly ? 'dropdown-categories col-4' : 'dropdown-categories'}
                        />
                        {!isMobileOnly && <div className="col-4"/>}
                        <form onSubmit={this.searchUpdated} name="searchForm"
                            className={!isMobileOnly ? 'search-bar-tutte-le-storie col-4' : (!isHidden ? 'search-bar-tutte-le-storie' : "search-bar-tutte-le-storie text-right")}>
                            <button className="tutte-le-storie-search-button" type="submit">
                                <svg className="magnifier-tutte-le-storie">
                                    <use xlinkHref={`${magnifier}${SVG_ID}`} />
                                </svg>
                            </button>
                            <input name="search" className="search-input" />
                        </form>
                    </div>
                </div>
                <div className="container">
                    <div className="row tutte-le-storie-card-row">
                        {(filteredCards && filteredCards.length > 0) ? filteredCards.map((card, index) => {

                            return <div className={isMobileOnly ? "col-xl-4 col-md-6 p-0" : "col-xl-4 col-md-6"} key={index}>
                                <div className="tutte-le-storie-card mx-auto">
                                    {(card.video) ?
                                        <div className="tutte-le-storie-card-video-container">
                                            <ReactPlayer className="card-video w-100 h-100"
                                                         url={card.video}
                                                         ref={this.myRef} controls={!this.state.isHidden}
                                                         playing={this.state.playing}
                                                         light={card.img}
                                                         onClick={this.playVideo.bind(this)}/>
                                            {!this.state.isHidden && !card.img &&
                                            <button className="card-video-button"
                                                    onClick={this.playVideo.bind(this)}>
                                                <div className="card-video-triangle"/>
                                            </button>}
                                        </div>
                                    :
                                        (card.img) ?
                                            <div className="tutte-le-storie-card-img-container">
                                                <img src={card.img} alt="Luiss.it" className="tutte-le-storie-card-img"/>
                                            </div>
                                                :
                                            <div className="tutte-le-storie-card-title">{card.title}</div>
                                    }
                                    <div className={'wrap-content'}>
                                        <div className={(card.video || card.img) ? "tutte-le-storie-card-img-content" : "tutte-le-storie-card-content"} {...insertHtml(card.title)} />
                                        <div className="tutte-le-storie-card-cta"><a href={card.link_url}>{card.link_title}</a></div>
                                    </div>
                                </div>
                            </div>
                        }) : <p className={'not-found'}>Nessuna Storia</p>}
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                {(allData.next_page !== '' && filteredCards && filteredCards.length > 0) &&
                                    <button className="tutte-le-storie-carica-altro-btn" onClick={() => this.showMore(allData.next_page)}>
                                        {allData.loadmore_label}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TutteLeStorie;
